import { createFileRoute } from '@tanstack/react-router';
import { LotesPage } from '@/components/lotes/lotes-page';

export const Route = createFileRoute('/_app/custos/atualizacoes/')({
  component: LotesPage,
});
